<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">订单详情</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">订单号</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{autoSignOrder.orderNum}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">订单描述</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{autoSignOrder.orderDesc}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">价格</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{autoSignOrder.price}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">任务编号</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{autoSignOrder.taskNum}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">创建时间</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{autoSignOrder.createTime | formatDateTime}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">支付方式</label>
              <div class="col-sm-10">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="payWay" value="1" disabled>
                  <label class="form-check-label" for="inlineRadio1">微信</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="payWay" value="2" checked>
                  <label class="form-check-label" for="inlineRadio2">支付宝</label>
                </div>
              </div>
            </div>
          </form>
          <div id="pay_qrcode">
            <img v-if="payWay=='1'" style="height: 2em;" src="/static/img/WePayLogo.png">
            <img v-else style="width:10em" src="../assets/img/logo_alipay.jpg">
            <p></p>
            <div>
              <div id="qrcode" style="display: none"></div>
              <span class="qrcode" title>
                <img style="height:10em" alt="Scan me!" src>
              </span>
            </div>
            <br>
            <p style="color:#F76C24">支付成功后，请到 >> 签名管理 页面核查 如有疑问联系客服：{{_Global.QQ}}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="pay" type="button" class="btn btn-primary" :disabled="pay_button_disabled">立即支付</button>
        </div>
      </div>
    </div>
    <WebSocket v-on:webSocketHandle="webSocketHandle" />
  </div>
</template>
<script>
var self;
import WebSocket from "./WebSocket";
export default {
  props: ["autoSignOrder"],
  components: {
    WebSocket
  },
  data() {
    return {
      wx_pay_qrcode: null,
      pay_button_disabled: false,
      money: null
    };
  },
  mounted() {
    self = this;
    $("#pay_qrcode").hide();
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("closeAutoSignAgainOrderDetail", false);
      });
    });
  },
  methods: {
    pay: function() {
      var payWay = $("input:radio[name='payWay']:checked").val();
      var orderNum = this.autoSignOrder.orderNum;
      window.layer.msg("正在生成第三方支付订单，请耐心等待", {
        time: 999999
      });
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/auto/sign/pay", {
          payWay: payWay,
          orderNum: orderNum,
          authToken: this.getToken()
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            window.layer.closeAll();
            $("#pay_qrcode").show();
            self.pay_button_disabled = true;
            var qrcode = jQuery("#qrcode").qrcode(data.code_url);
            var canvas = qrcode.find("canvas").get(0);
            $(".qrcode img").attr("src", canvas.toDataURL("image/jpg"));
          });
        });
    },
    webSocketHandle: function(data) {
      console.log("tag", data);
      var obj = JSON.parse(data);
      if (obj.orderNum !== this.autoSignOrder.orderNum) {
        return;
      }
      window.layer.msg("支付成功,页面正在跳转...");
      setTimeout(function() {
        $("#app_info_modal").modal("hide");
        window.location.reload();
      }, 2000);
    }
  }
};
</script>
<style scoped>
.content {
  text-align: left;
}
.modal-body {
  text-align: center;
}
.form-check {
  margin-right: 1em;
  margin-left: 0;
}
.modal-footer button {
  text-align: center;
  width: 100%;
}

.form-group div {
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/components/AutoSignAgainOrderDetail.vue